<template>

<div class="parent-container">
  <NavHeader></NavHeader>

  <wanted-people ></wanted-people>

</div>

</template>

<script>

import NavHeader from "@/components/NavHeader.vue";
import WantedPeople from "@/components/WantedPeople.vue";



export default {
  name: 'App',
  components: {

    WantedPeople,
    NavHeader,


  },

}
</script>

<style>
 body{
   background-color:#002580 ;
   font-family: 'montserrat',sans-serif;

 }
 .parent-container{
   max-width: 1280px;
   margin: auto;

 }


</style>
